import { render, staticRenderFns } from "./MetadataRepresentation.vue?vue&type=template&id=c87f6010&scoped=true&"
import script from "./MetadataRepresentation.vue?vue&type=script&lang=js&"
export * from "./MetadataRepresentation.vue?vue&type=script&lang=js&"
import style0 from "./MetadataRepresentation.vue?vue&type=style&index=0&id=c87f6010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87f6010",
  null
  
)

export default component.exports